import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input, Alert, Row, Col } from "antd";
import "antd/dist/antd.css";

type HeaderProps = {
  text: String;
  headingColor?: string;
  size?: number;
};

function HeaderText(props: HeaderProps) {
  const { text, headingColor, size } = props;

  return (
    <text
      className="header_text"
      style={{ color: headingColor, fontSize: size }}
    >
      {text}
    </text>
  );
}

HeaderText.defaultProps = {
  headingColor: "black",
  size: 22,
};

export default HeaderText;
